import React, { useEffect, useRef, useState } from 'react'
import styles from './testimonialCard.module.css'
import { IoStar } from "react-icons/io5";

function TestimonialCard({ quote, author, rating}) {
    const avatar = author.split(" ").map(name => name[0]).join("");
    const quoteRef = useRef(null);
    const [expanded, setExpanded] = useState(false);
    const [overflowing, setOverflowing] = useState(false);

    useEffect(() => {
        const el = quoteRef.current;
        if (!el || expanded) return;
        const measure = () => setOverflowing(el.scrollHeight > el.clientHeight + 1);
        measure();
        const observer = new ResizeObserver(measure);
        observer.observe(el);
        return () => observer.disconnect();
    }, [quote, expanded]);

    return (
        <div className={styles.container}>
            <div className={styles.rating}>
                {Array.from({ length: rating }, (_, index) => (
                    <IoStar key={index} />
                ))}
            </div>
            <div className={styles.quoteContainer}>
                <p ref={quoteRef} className={`${styles.quote} ${expanded ? '' : styles.clamped}`}>"{quote}"</p>
                {(overflowing || expanded) && (
                    <button
                        type="button"
                        className={`${styles.toggle} ${expanded ? '' : styles.overlay}`}
                        aria-expanded={expanded}
                        // Keep CardStack's pointer capture from swallowing the click
                        onPointerDown={e => e.stopPropagation()}
                        onClick={() => setExpanded(value => !value)}
                    >
                        <span>{expanded ? 'Show less' : 'Show more'}</span>
                    </button>
                )}
            </div>

            <div className={styles.authorContainer}>
                <div className={styles.avatar}>{avatar}</div>
                <p className={styles.author}>{author}</p>
            </div>

        </div>
    )
}

export default TestimonialCard
